module.exports = __webpack_public_path__ + "public/images/icons/star.d951965fac98ea7da3248129d89d262b.svg";